import { Block } from '../../wordpress/types_and_parser/standard_blocks.gen'
import { CMSState } from '../../cms/blocks/types.gen'
import { CustomBlock } from '../../wordpress/types_and_parser/custom_blocks.mod'
import { HeroBlock } from '../blocks/custom_blocks/widgets/heroBlock.mod'
import { Page } from '../../cms/page/types.gen'
import { PublicSite_CustomPageData } from '../application.mod'
import { toRelativeUrl } from '../../../helpers'
import { Widget, mk_widget, AsyncState } from 'widgets-for-react'
import { WordPress } from '../../wordpress/wordpress_api'
import React from 'react'
import { TextBlock } from '../blocks/custom_blocks/widgets/textBlock.mod'
import { textBlockClasses, heroBlockClasses } from '../blocks/style.mod'
import { PublicSiteState } from '../../public_site.main.mod'

export const formOverview: (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  forms: AsyncState<Array<WordPress.PostTypeResponse>>,
  state:PublicSiteState
) => Widget<never> = (
  page: Page<CustomBlock, Block, PublicSite_CustomPageData>,
  forms: AsyncState<Array<WordPress.PostTypeResponse>>,
  state:PublicSiteState
) =>
  mk_widget({
    run: _ => {
      const hero = page.blocks.filter(b => b.kind == "vidda/hero" && b).pop()
      return <>
        { hero && hero.kind == 'vidda/hero' && 
          HeroBlock({
            blockName: 'vidda/hero',
            title: hero.attrs.title,
            intro: hero.attrs.intro,
            header_type: 'header-2',
            show_image: false
          },
          { style: heroBlockClasses }
        )({} as CMSState<{}, {}, never>)(state).run(_ => {})}

        { forms.kind == 'loaded' && 
          <div className="list-overview">
            {forms.value.map(update => (
              TextBlock({
                key: `form-item-${update.slug}`,
                title: update.title.rendered,
                text: update.excerpt.rendered ? update.excerpt.rendered : update.content.rendered,
                link: {
                  is_link_external: false,
                  kind: "link",
                  target: "_self",
                  title: "Naar formulier",
                  url: toRelativeUrl(update.link)
                }, 
                navigation_title: "", 
                show_in_page_navigation: false
              }, {style: textBlockClasses})({} as CMSState<{}, {}, never>)(state).run(_ => {}) 
            ))}
          </div>
        }
      </>
    }
  })



// WEBPACK FOOTER //
// ./Client/components/public_site/templates/form_overview.tsx